export const signupStates = {
	UNKNOWN: 0,
	ACCEPTED: 1,
	TENTATIVE: 2,
	DECLINED: 3
};

export interface PresenceItem {
	id: number;
	icon: string;
	color: string;
	name: string;
	selectable: boolean;
};

const presenceItems: PresenceItem[] = [
	{
		id: signupStates.ACCEPTED,
		icon: "fas fa-check",
		color: "success",
		name: "composition.state[1]",
		selectable: true
	},
	{
		id: signupStates.TENTATIVE,
		icon: "fas fa-question",
		color: "warning",
		name: "composition.state[2]",
		selectable: true
	},
	{
		id: signupStates.DECLINED,
		icon: "fas fa-times",
		color: "error",
		name: "composition.state[3]",
		selectable: true
	},
	{
		id: signupStates.UNKNOWN,
		icon: "fas fa-question",
		color: "grey lighten-1",
		name: "composition.state[0]",
		selectable: false
	}
];

export default presenceItems;